import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from "@angular/router";
import { AuthService } from "./auth.service";
import { Preferences } from "@capacitor/preferences";

@Injectable({ providedIn: "root" })
export class AuthGuard  {
  currentUser;
  constructor(
    private router: Router,
    private authenticationService: AuthService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.currentUser = await this.authenticationService.currentUser();
    const { value: isLogged } = await Preferences.get({ key: "logged" });

    if (
      !!this.currentUser &&
      !this.currentUser.value &&
      route.data.roles &&
      route.data.roles.indexOf("All") !== -1
    ) {
      return true;
    }
    if (this.currentUser && this.currentUser.value) {
      if (
        route.data.roles &&
        route.data.roles.indexOf(this.currentUser.displayName) === -1
      ) {
        this.router.navigate(["/login"]);
        return false;
      }
      return true;
    }
    if (isLogged) {
      return true;
    } else {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}
